import { ErrorLayout } from '@/layout/error/error-layout';

const NotFoundPage = () => (
    <ErrorLayout title="Page Not Found" subtitle={`Sorry, there doesn't seem to be anything at this address.`} />
);

NotFoundPage.getLayout = (page: React.ReactElement) => {
    return page;
};

export default NotFoundPage;
